export default {
  // Navigation Tabs & Menus
  tabs: {
    home: 'Home',
    services: 'Services',
    orders: 'Orders',
    wallet: 'Wallet',
    profile: 'Profile',
  },

  nav: {
    dashboard: 'Dashboard',
    new_order: 'New Order',
    services: 'Services',
    orders: 'Orders',
    deposit: 'Deposit',
    virtual_numbers: 'Virtual Numbers',
    referrals: 'Referral Program',
    settings: 'Settings',
    support: 'Support',
    guide: 'Guide',
    logout: 'Logout',
    login: 'Log In',
    signup: 'Get Started',
    features: 'Features',
    platforms: 'Platforms',
    how_it_works: 'How It Works',
    pricing: 'Pricing',
    faq: 'FAQ',
    language: 'Language',
  },

  // Common UI
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    submit: 'Submit',
    copied: 'Copied to clipboard',
    search: 'Search...',
    all: 'All',
    completed: 'Completed',
    pending: 'Pending',
    in_progress: 'In Progress',
    failed: 'Failed',
    cancelled: 'Cancelled',
    partial: 'Partial',
    see_all: 'See All',
    details: 'Details',
    status: 'Status',
    close: 'Close',
    try_again: 'Try Again',
    error: 'Error',
    success: 'Success',
    something_went_wrong: 'Something went wrong. Please try again.',
    rate_per_1k: 'Rate per 1,000',
    min_max: 'Min / Max',
    action: 'Action',
    actions: 'Actions',
    category: 'Category',
    service: 'Service',
    quantity: 'Quantity',
    link: 'Link / URL',
    cost: 'Cost',
    total_cost: 'Total Cost',
    date: 'Date',
    order: 'Order',
    refresh: 'Refresh',
    delivery_time: 'Delivery Time',
    available_balance: 'Available Balance',
    add_funds: 'Add Funds',
    place_order: 'Place Order',
  },

  // Auth Screens
  auth: {
    welcome_title: 'Grow Your Social Media Presence',
    welcome_sub: 'The fastest, most reliable SMM platform for African & global creators.',
    login: 'Login',
    sign_up: 'Sign Up',
    sign_in: 'Sign In',
    email_or_username: 'Email address or username',
    password: 'Password',
    remember_me: 'Remember me',
    forgot_password: 'Forgot Password?',
    or_continue_with: 'Or continue with',
    google: 'Google',
    no_account: "Don't have an account?",
    have_account: 'Already have an account?',
    create_account: 'Create Account',
    full_name: 'Full Name',
    username: 'Username',
    email: 'Email Address',
    phone: 'Phone Number',
    confirm_password: 'Confirm Password',
    agree_terms: 'I agree to the Terms of Service & Privacy Policy',
    reset_password: 'Reset Password',
    send_code: 'Send Reset Code',
  },

  // Dashboard Screen
  dashboard: {
    greeting: 'Hello',
    grow_subtitle: 'Grow your social accounts today with fast delivery',
    current_balance: 'Current Balance',
    your_balance: 'Your Balance',
    add_funds: '+ Add Funds',
    quick_actions: 'Quick Actions',
    services_catalog: 'Services Catalog',
    order_now: 'Order Now',
    track_orders: 'Track Orders',
    wallet_topup: 'Wallet Topup',
    popular_services: 'Popular Services',
    recent_orders: 'Recent Orders',
    recent_subtitle: 'Track your latest service orders and delivery status',
    no_orders_yet: 'No orders placed yet',
    no_orders_desc: 'Select a service from our catalog to boost your channels today.',
    place_first_order: 'Place First Order',
    social_media_services: 'Social Media Services',
    social_media_subtitle: 'Boost your social media presence',
    virtual_numbers: 'Virtual Numbers',
    virtual_numbers_subtitle: 'Get virtual numbers for verification',
    popular_social_media_services: 'Popular Social Media Services',
    popular_virtual_numbers: 'Popular Virtual Numbers',
    fast_and_reliable: 'Fast & Automated Delivery',
    fast_and_reliable_sub: 'All orders start processing automatically within seconds of submission.',
    total_orders: 'Total Orders',
    all_time_completed: 'All time completed',
    total_spent: 'Total Spent',
    lifetime_volume: 'Lifetime volume',
    vn_used: 'Virtual Numbers Used',
    sms_verifications: 'SMS verifications',
    see_all_services: 'See all services',
    browse_countries: 'Browse all countries',
    view_all_orders: 'View All Orders →',
  },

  // Services Screen
  services: {
    title: 'Services',
    subtitle: 'Choose from 500+ premium social media growth packages.',
    promo_title: 'Grow Your Social Media Faster',
    promo_subtitle: 'Get followers, likes, views, and engagements at verified lowest rates with automated delivery.',
    quick_order: 'Quick Order',
    show_all_platforms: 'Show All Platforms',
    search_placeholder: 'Search by service name, category, or ID (e.g. 1024, TikTok, Instagram followers)...',
    all_categories: 'All Categories',
    popular_packages: 'Popular Packages',
    buy_now: 'Buy Now',
    order: 'Order',
    min: 'Min',
    max: 'Max',
    per_1k: 'per 1,000',
    instant_delivery: 'Instant Delivery',
    high_retention: 'High Retention',
    safe_secure: '100% Safe & Secure',
    no_services_found: 'No services found matching your search.',
    social_media_tab: 'Social Media',
    virtual_numbers_tab: 'Virtual Numbers',
    favorites: 'Favorites',
    all_platforms: 'All Platforms',
    grid_view: 'Cards',
    table_view: 'Table',
  },

  // Virtual Numbers
  virtual_numbers: {
    title: 'Virtual Numbers',
    subtitle: 'Get temporary or rental numbers to receive verification codes.',
    promo_title: 'Private Virtual Numbers for Any Service',
    promo_desc: 'Get temporary numbers for verification on apps and websites with instant SMS delivery.',
    buy_number: 'Buy Number',
    orders: 'Orders',
    rents: 'Rent Number',
    my_numbers: 'My Numbers',
    instant_delivery: 'Instant delivery',
    wide_selection: 'Wide country selection',
    affordable_prices: 'Affordable prices',
    popular_countries: 'Popular Countries',
    popular_services: 'Popular Services',
    select_country: 'Select Country',
    select_service: 'Select Service',
    choose_number: 'Choose Number',
    order_summary: 'Order Summary',
    step_payment: 'Payment',
    continue_payment: 'Continue to Payment',
    number_activated: 'Number Activated',
    number_ready: 'Your virtual number is ready to use.',
    time_remaining: 'Time Remaining',
    received_codes: 'Received Codes',
    no_codes_yet: 'No codes yet',
    codes_auto_appear: 'Codes received for this number will appear here automatically.',
    instructions_text: 'Open the app and enter this number to receive your verification code. New codes will appear automatically.',
    extend: 'Extend',
    rent_again: 'Rent Again',
    cancel: 'Cancel',
    all_codes: 'All Codes',
    unread: 'Unread',
    available: 'Available',
    refresh: 'Refresh',
    phone_number: 'Phone Number',
    view_all: 'View All >',
    select_provider: 'Select Provider',
    live_rates: 'Live Rates',
    choose_provider_sub: 'Choose your preferred virtual numbers provider:',
    instant_sms_desc: 'Instant SMS verification',
    global_pool_desc: 'Global pool & broad coverage',
    country: 'Country',
    service: 'Service',
    provider: 'Provider',
    price: 'Price',
    auto_assigned: 'Auto-assigned on purchase',
    pay_activate_btn: 'Pay & Activate Number',
    number_details: 'Number Details',
    number_details_sub: 'Your number has been activated. Use it to receive verification codes.',
    waiting_for_code: 'Waiting for SMS code...',
    instructions: 'Instructions',
    instructions_prefix: 'Open',
    instructions_suffix: 'and enter this number to receive your verification code. New codes will appear automatically.',
    view_all_received_codes: 'View All Received Codes →',
    search_service_placeholder: 'Search service (WhatsApp, Telegram...)',
    search_country_placeholder: 'Search country...',
    no_services_found: 'No services found',
    no_countries_found: 'No countries found',
    no_numbers_yet: 'No numbers yet',
    no_numbers_sub: 'When you purchase a virtual number, it will show up here.',
    buy_a_number: 'Buy a Number',
    my_rents: 'My Rents',
    my_rents_sub: 'Manage your rented numbers, extend rentals and view their status.',
    search_rent_placeholder: 'Search number, service or country...',
    active: 'Active',
    expiring: 'Expiring',
    expired: 'Expired',
    all: 'All',
    back_to_services: '‹ Back to All Services',
    back_to_countries: '‹ Back to Countries',
    select_country_continue: 'Select a country to continue your purchase',
    success_rate: 'Success Rate',
    confirm_purchase_title: 'Confirm Number Purchase',
    confirm_purchase_sub: 'Verify your order details before activating the virtual number.',
    total_deducted: 'Total to be deducted',
    your_new_balance: 'Your balance after purchase',
    insufficient_balance: 'Insufficient balance to purchase this number.',
    deposit_to_continue: 'Please deposit funds into your wallet to proceed.',
  },

  // New Order Screen
  new_order: {
    title: 'Place Order',
    subtitle: 'Fill in your target link and quantity to boost your social profile.',
    service_selected: 'Selected Service',
    category_label: 'Category',
    select_category: 'Select Category',
    service_label: 'Service',
    select_service: 'Select Service',
    link_label: 'Link / Target URL',
    link_placeholder: 'https://instagram.com/yourprofile or post URL',
    link_helper: 'Make sure the profile or post is public',
    quantity_label: 'Quantity',
    min_max: 'Min: {min} — Max: {max}',
    total_price: 'Total Price',
    place_order_btn: 'Place Order Now',
    order_success_title: 'Order Placed Successfully!',
    order_success_sub: 'Your order is being processed and will start delivering shortly.',
    order_id: 'Order ID',
    track_orders_btn: 'Track in Orders',
    back_to_services_btn: 'Back to Services',
    comments_label: 'Custom Comments',
    comments_placeholder: 'Enter one comment per line...',
    comments_badge: '{count} comment(s)',
    rate_per_1k: 'Rate / 1K',
    delivery_time: 'Delivery Time',
    service_description: 'Service Description',
    quick_presets: 'Quick Presets',
    insufficient_balance: 'Insufficient Balance',
    insufficient_sub: 'You need more funds in your wallet to place this order.',
    deposit_now: 'Add Funds Now',
    order_summary: 'Order Summary',
  },

  // Orders Screen
  orders: {
    title: 'My Orders',
    subtitle: 'Track your live order deliveries and status.',
    search_placeholder: 'Search by Order #ID, service name, or link URL...',
    filter_all: 'All Orders',
    filter_pending: 'Pending',
    filter_progress: 'In Progress',
    filter_completed: 'Completed',
    filter_partial: 'Partial',
    filter_cancelled: 'Canceled',
    no_orders_found: 'No orders found matching this filter.',
    progress: 'Delivery Progress',
    view_cards: 'Cards',
    view_table: 'Table',
    order_num: 'Order',
    service_col: 'Service',
    quantity_col: 'Quantity',
    cost_col: 'Cost',
    status_col: 'Status',
    date_col: 'Date',
    link_col: 'Link',
    copy_link: 'Copy Link',
    open_link: 'Open Link',
  },

  // Wallet / Deposit Screen
  wallet: {
    title: 'Wallet',
    subtitle: 'Add funds to your wallet to place orders easily.',
    current_balance: 'Available Balance',
    add_funds: 'Add Funds',
    transaction_history: 'Transaction History',
    select_amount: 'Select Amount',
    custom_amount: 'Custom Amount',
    enter_amount_placeholder: 'Enter amount (e.g. 5000)',
    select_payment_method: '1. Select Payment Method',
    phone_number: 'Phone Number',
    proceed_to_payment: 'Proceed to Payment',
    secure_payments: 'Your payments are secure and encrypted.',
    instant_addition: 'Funds are added to your wallet instantly after successful payment.',
    recent_transactions: 'Recent Transactions',
    bonus_title: 'First Deposit Bonus Activated!',
    bonus_desc: 'Get an extra bonus instantly added to your wallet on your first deposit!',
    quick_amounts: 'Quick Amounts',
    one_tap_fill: '1-Tap Fill',
    amount_in: 'Amount in {currency}',
    depositing: 'You are depositing',
    credited_to_wallet: 'Credited to Wallet',
    no_transactions: 'No transactions yet',
    no_transactions_sub: 'Your deposits and refunds will appear here once processed.',
    pay_now: 'Pay Now',
  },

  // Settings Screen
  settings: {
    title: 'Account Settings',
    subtitle: 'Manage your profile preferences, regional currency, security credentials, and API access.',
    tab_preferences: 'Preferences & Currency',
    tab_security: 'Security & Password',
    tab_api: 'API & Reseller Key',
    loc_title: 'Localization & Currency',
    loc_subtitle: 'Set your location, preferred language and currency for orders, balance, and payment methods.',
    field_country: 'Primary Country',
    field_country_desc: 'Mobile Money and localized payment options will default to this country.',
    field_currency: 'Account Display Currency',
    field_language: 'Preferred Language',
    field_language_desc: 'Select the display language for the platform interface and notifications.',
    btn_save_preferences: 'Save Preferences',
    btn_saving_preferences: 'Updating Preferences...',
    msg_preferences_saved: 'Preferences updated successfully!',
    security_title: 'Change Password',
    security_sub: 'Ensure your account stays protected by using a unique password.',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    btn_update_password: 'Update Password',
    api_title: 'API & Reseller Access',
    api_sub: 'Integrate NiceBooster services directly into your own app or SMM panel.',
    api_key_label: 'Your API Secret Key',
    generate_key: 'Generate New Key',
    copy_key: 'Copy Key',
    reseller_status: 'Reseller API Access',
  },

  // Support Screen
  support: {
    title: 'Help & Support',
    subtitle: 'Get in touch with our 24/7 dedicated customer care team.',
    whatsapp_chat: 'Chat on WhatsApp',
    whatsapp_desc: 'Fastest response — average reply under 5 minutes',
    telegram_chat: 'Telegram Support',
    telegram_desc: 'Instant assistance from our specialized agents',
    email_support: 'Email Support',
    email_desc: 'For billing, inquiries, or enterprise partnerships',
  },

  // Landing Page
  landing: {
    hero_title_1: 'Accelerate Your Social Growth at',
    hero_title_2: 'Wholesale Rates',
    hero_subtitle: 'The all-in-one automated platform for creators, agencies, and businesses. Boost followers, likes, views across all major networks, and get instant virtual phone numbers for SMS verification.',
    hero_cta_free: 'Get Started Free',
    hero_view_catalog: 'View Services Catalog',
    hero_trusted: 'Trusted by 50,000+ creators • MoMo & Crypto accepted',
    stat_delivered_today: 'Delivered Today',
    stat_sms_received: 'SMS Received',
    stat_orders_completed: 'Orders Completed',
    stat_active_creators: 'Active Creators & Agencies',
    stat_uptime: 'Automated System Uptime',
    stat_speed: 'Average Start Speed',
    live_order_network: 'Live Order Network',
    recent_activity: 'Recent Activity',
    final_cta_title: 'Supercharge Your Social Presence Today',
    final_cta_subtitle: 'Join over 50,000 creators, digital brands, and marketing agencies growing effortlessly with NiceBooster.',
    create_free_account: 'Create Free Account',
    talk_to_support: 'Talk to Support',
    footer_nav: 'Navigation',
    footer_account: 'Account',
    footer_support: 'Support & Legal',
  },

  // Flat keys for backwards compatibility
  nav_dashboard: 'Dashboard',
  nav_new_order: 'New Order',
  nav_services: 'Services',
  nav_orders: 'Orders',
  nav_deposit: 'Deposit',
  nav_virtual_numbers: 'Virtual Numbers',
  nav_referrals: 'Referral Program',
  nav_settings: 'Settings',
  nav_support: 'Support',
  nav_guide: 'Guide',
  nav_logout: 'Logout',
  nav_login: 'Log In',
  nav_signup: 'Get Started',
  nav_features: 'Features',
  nav_platforms: 'Platforms',
  nav_how_it_works: 'How It Works',
  nav_pricing: 'Pricing',
  nav_faq: 'FAQ',
  nav_language: 'Language',
  settings_title: 'Account Settings',
  settings_subtitle: 'Manage your profile preferences, regional currency, security credentials, and API access.',
  tab_preferences: 'Preferences & Currency',
  tab_security: 'Security & Password',
  tab_api: 'API & Reseller Key',
  loc_title: 'Localization & Currency',
  loc_subtitle: 'Set your location, preferred language and currency for orders, balance, and payment methods.',
  field_country: 'Primary Country',
  field_country_desc: 'Mobile Money and localized payment options will default to this country.',
  field_currency: 'Account Display Currency',
  field_language: 'Preferred Language',
  field_language_desc: 'Select the display language for the platform interface and notifications.',
  btn_save_preferences: 'Save Preferences',
  btn_saving_preferences: 'Updating Preferences...',
  msg_preferences_saved: 'Preferences updated successfully!',
  dash_smm_services: 'Social Media Services',
  dash_smm_desc: 'Boost your followers, likes, views & engagement across all platforms',
  dash_vn_title: 'Virtual Numbers',
  dash_vn_desc: 'Receive instant SMS verification codes with private rental numbers',
  dash_popular_smm: 'Popular Social Media Services',
  dash_see_all_services: 'See all services',
  dash_popular_vn: 'Popular Virtual Numbers',
  dash_browse_countries: 'Browse all countries',
  dash_top_up: '+ Top up',
  dash_total_orders: 'Total Orders',
  dash_all_time_completed: 'All time completed',
  dash_total_spent: 'Total Spent',
  dash_lifetime_volume: 'Lifetime volume',
  dash_vn_used: 'Virtual Numbers Used',
  dash_sms_verifications: 'SMS verifications',
  dash_recent_orders: 'Recent Orders',
  dash_recent_subtitle: 'Track your latest service orders and delivery status',
  dash_refresh: 'Refresh',
  dash_view_all_orders: 'View All Orders →',
  col_order: 'Order',
  col_service: 'Service',
  col_quantity: 'Quantity',
  col_cost: 'Cost',
  col_status: 'Status',
  col_date: 'Date',
  no_orders_placed: 'No orders placed yet',
  no_orders_desc: 'Select a service from our catalog to boost your channels today.',
  place_first_order: 'Place First Order',
  hero_title_1: 'Accelerate Your Social Growth at',
  hero_title_2: 'Wholesale Rates',
  hero_subtitle: 'The all-in-one automated platform for creators, agencies, and businesses. Boost followers, likes, views across all major networks, and get instant virtual phone numbers for SMS verification.',
  hero_cta_free: 'Get Started Free',
  hero_view_catalog: 'View Services Catalog',
  hero_trusted: 'Trusted by 50,000+ creators • MoMo & Crypto accepted',
  stat_delivered_today: 'Delivered Today',
  stat_sms_received: 'SMS Received',
  stat_orders_completed: 'Orders Completed',
  stat_active_creators: 'Active Creators & Agencies',
  stat_uptime: 'Automated System Uptime',
  stat_speed: 'Average Start Speed',
  live_order_network: 'Live Order Network',
  recent_activity: 'Recent Activity',
  final_cta_title: 'Supercharge Your Social Presence Today',
  final_cta_subtitle: 'Join over 50,000 creators, digital brands, and marketing agencies growing effortlessly with NiceBooster.',
  create_free_account: 'Create Free Account',
  talk_to_support: 'Talk to Support',
  footer_nav: 'Navigation',
  footer_account: 'Account',
  footer_support: 'Support & Legal',
  available_balance: 'Available Balance',
  add_funds: 'Add Funds',
  place_order: 'Place Order',
  category: 'Category',
  service: 'Service',
  quantity: 'Quantity',
  link: 'Link',
  total_cost: 'Total Cost',
  status: 'Status',
  actions: 'Actions',
  search: 'Search',
  cancel: 'Cancel',
  loading: 'Loading...',
  close: 'Close',
};
